export const enPatientOverviewTranslations = {
  patientOverview: {
    widgets: {
      recommendationsLandmark: 'Recommendations',
      fallRiskAssessment: {
        fallRiskAssessmentTitle: 'Fall risk assessment',
        assessmentPrompt: 'What is contributing to this fall risk?',
        document: 'Document',
        scoreTitleToday: "Today's score",
        scoreTitleCurrent: 'Latest score',
        fallRiskDataModal: {
          header:
            '{{name}} is considered to be at a {{measurement}} fall risk because of the following indicators:',
        },
        passiveDataIndicators: {
          calloutLabel: 'Passive data is included in the fall risk calculation (when available)',
          passiveDataExplainerDialogTitle: 'Passive data is included in the fall risk calculation',
          passiveDataExplainerDialogContent:
            'Fall Risk scores combine active test results with background mobility data (when available) for a more full view of mobility.\nEncourage patients to enable background data in the app so their daily movement is reflected in the score.',
          passiveBadgeContent: 'Passive',
          passiveBadgeTooltip: 'Based on passive recordings',
        },
      },
      fallRiskTrend: {
        fallRiskTendTitle: 'Fall risk trend',
        uptoDateData: 'Measurements ≤{{days}} days apart',
        outdatedData: 'Measurements >{{days}} days apart',
        indicatorsPrompt: 'What determines the impact of each fall risk indicator?',
        trendDialog: {
          indicatorImpactIntro:
            'The fall risk indicators are updated whenever new measurements are added. Their impact on fall risk assessment depends on:',
          keyIndicators: 'Indicator importance:',
          keyIndicatorsDetail: ' Some indicators have a greater impact on fall risk than others.',
          recentData: 'Measurement recency:',
          recentDataDetail:
            ' Indicators from more recent measurements have a greater influence on the assessment.',
          viewTopIndicators:
            'You can view the top 5 indicators contributing to each assessment by hovering over the trend line.',
        },
        emptyState: {
          title: 'No fall risk trend data available',
          description:
            'Take multiple measurements over time to see trends and patterns in fall risk assessment',
        },
        outDateState: {
          title: 'Based on old or partial data.',
          lastValidScore: 'Last valid score: {{date}}. Record a new walk to update it.',
        },
      },
      legacyRecommendation: {
        recommendationTitle: 'Recommendations',
        emptyState: {
          title: 'No recommendations available yet',
          description:
            'Keep tracking your patient’s progress - more data will help generate personalized recommendations.',
        },
      },
      recommendation: {
        declineSuccess:
          'Thanks for the feedback — we’ll factor it into this patient’s future recommendations.',
        errors: {
          declineFailed: 'Couldn’t decline this recommendation. Please try again.',
          addFailed: 'Couldn’t add this recommendation to the HEP. Please try again.',
          alreadyResolved: 'This recommendation was already handled.',
        },
      },
      whatsChanged: {
        whatsChangedTitle: 'What’s changed',
        comparison: {
          last_week: 'Compared to the previous week',
          last_month: 'Compared to the previous month',
          current_month_to_previous_month: 'Compared to the same period last month',
          previous_measurement: 'Compared to previous measurement',
        },
        showMore: 'Show more parameters',
        showLess: 'Show less parameters',
        emptyState: {
          title: 'No significant changes to show',
          description: 'This may be the result of no major changes or limited measurement data',
        },
      },
      walkScoreSummary: {
        title: 'Walk score',
        parametersList: {
          title: 'What defines the walk score?',
          subtitle: 'The walk score is calculated based on key walking characteristics such as:',
          footer: 'These factors help reflect the quality of a person’s walk.',
          parameters: {
            CADENCE: '<strong>Cadence</strong> (step rate)',
            VELOCITY: '<strong>Velocity</strong> (speed)',
            VELOCITY_VARIABILITY: '<strong>Step variability</strong>',
            CONSISTENCY: '<strong>Consistency</strong>',
          },
          whatsChangedList: [
            'The walk score is an aggregate of multiple gait parameters providing together a measure of gait quality.',
            'The score is measured on a scale from 0 to 100',
            'Any score above 65 is considered to be within a typical range for most people.',
            'The walk score is a great tool to engage patients, provide biofeedback, and track gait quality trends over time.',
          ],
        },
        showMoreButton: 'Show detailed parameters',
        progressIndicator: {
          ofMaxSub: 'of {{max}}',
          latestScore: 'Latest score',
          viewActivityLog: 'View progress tab',
          scorePlaceholder: 'Score',
        },
        latestWalkScore: 'Active walk',
        latestPassiveWalkScore: 'Passive walk',
        walkScoreTooltip: `The walk score is an aggregate of multiple gait parameters providing together a measure of gait quality. The score is measured on a scale from 0 to 100. Any score above 65 is considered to be within a typical range for most people. The walk score is a great tool to engage patients, provide biofeedback, and track gait quality trends over time.`,
        emptyState: {
          title: 'Walk score unavailable',
          description: ' Data will appear here once recorded',
        },
        recentWalks: 'Recent walks',
        dailyAverage: 'Daily Average',
        score: 'Score: {{value}}',
        viewAll: 'View all activities',
      },
      parameters: 'Parameters',
      viewDetailedParameters: 'View detailed parameters',
      walkSummary: 'Summary',
      viewWalkSummary: 'View walk summary',
      oneStepAgent: 'OneStep Agent',
      oneStepAgentPanel: {
        resize: 'Resize OneStep Agent panel',
        unavailable:
          "The OneStep Agent couldn't open for this patient. Reload the page, or contact support if it keeps happening.",
      },
      walkScoreTrendWidget: {
        walkScoreTrendTitle: 'Walk score trend',
      },
    },
    emptyState: {
      title: 'Not enough measurements available',
      description:
        'Start or continue taking measurements to assess fall risk and track progress over time.',
    },
    walkScoreEmptyState: {
      title: 'No measurements taken',
      description:
        'Start taking measurements to assess the walk score and track progress over time.',
    },
    unAvailableState: {
      title: 'Patient overview not available',
      goToPatientProfile: 'Go to patient’s profile',
      description: `The patient does not have an active episode of care. To assign the patient a new episode of care, navigate to the patient's profile.`,
    },
    copyForEmr: 'Copy for EMR',
  },
};
